import { apiClient } from './client';
import type { SecurityAlertsSummary } from '../types';

export const securityAlertsApi = {
  async getSummary(): Promise<SecurityAlertsSummary> {
    const { data } = await apiClient.get<SecurityAlertsSummary>('/security-alerts/summary');
    return data;
  },
};
